/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Logger } from '@squiz/dx-logger-lib';
import fsp from 'fs/promises';

/**
 * Clean up temporary directory
 * @param tmpDir - Temporary directory path to clean up
 * @param logger - Logger instance
 */
export async function cleanupTmpDir(tmpDir: string, logger: Logger): Promise<void> {
  await fsp.rm(tmpDir, { force: true, recursive: true }).catch((error: any) => {
    logger.error('failed to remove temp directory', error);
  });
}
